import { nanoid, PayloadAction } from "@reduxjs/toolkit";
import type { AsVo } from "src/vo/asVo";
import { createSlice, createSelector } from "@reduxjs/toolkit";
import { stringParsing } from "src/utils/stringPasingUtil";
import moment from "moment";
import { useEffect } from "react";

// vo 객체 활용
const initialState: AsVo = {
  progress: 0,
  filterData: "",
  searchCate: [],
  searchStore: [],
  searchDate: [],
  searchContentsData: "",
  selectedChips: [],
  listChips: [],
  setDataList: [],
  company_name: "",
  searchStartDate: "",
  searchEndDate: "",
  ingAsRegister: false,
  ingReportRegister: false,
};

// 2. slice 생성 : createSlice
// reducer는 두 가지 인자를 받는데, 첫 번째는 이전 상태 정보가 들어오고 두 번째 인자는 아까 위에서 발생한 액션 객체
const asSlice = createSlice({
  name: "as",
  initialState,
  reducers: {
    initData: (state) => {
      state.selectedChips = [
        {
          title: "선택한 조건",
          chip: [], // naming
          check: [], // 선택 여부
          index: [], // 위치
          code: [],
          contents: "", // 검색어
          orderBy: "", // 정렬
          page: 1,
        },
      ];

      state.listChips = [
        {
          title: "A/S 유형",
          chip: ["마감재", "집기", "마네킨", "영상", "간판/로고", "설비/누수/소방", "전기/조명", "음향", "기타"],
          check: [false, false, false, false, false, false, false, false, false],
          code: ["1201000", "1202000", "1203000", "1206000", "1207000", "1208000", "1204000", "1205000", "1209000"],
        },
        {
          title: "매장 유형",
          chip: ["직영점", "대리점", "백화점", "아울렛", "팩토리", "면세점"],
          check: [false, false, false, false, false, false],
          code: ["C", "B", "A", "O", "F", "ADF"],
        },
        {
          title: "기간",
          chip: ["1개월", "3개월", "6개월", "12개월"],
          check: [false, false, false, false],
          code: [1, 3, 6, 12],
        },
      ];
    },
    filterHandleClick: (state, action: PayloadAction<any>) => {
      if (action.payload) {
        const params = action.payload;
        const paramEvent = params.event;
        const paramIndex = params.index;
        const elementName = action.payload.event.currentTarget.textContent;
        const idx = paramIndex;
        let codeName = "";
        if (!(paramEvent.currentTarget.className.indexOf("selected") > -1)) {
          const titleName: any = paramEvent.currentTarget.parentElement?.parentElement?.childNodes[0].textContent;
          // 색상 변경
          if (titleName.indexOf("A/S 유형") > -1) {
            state.selectedChips![0].check.push("A");
            state.listChips![0].check[idx] = true;
            codeName = state.listChips![0].code[idx];
            state.selectedChips![0].code.push(codeName);
          } else if (titleName.indexOf("매장 유형") > -1) {
            state.selectedChips![0].check.push("B");
            state.listChips![1].check[idx] = true;
            codeName = state.listChips![1].code[idx];
            state.selectedChips![0].code.push(codeName);
          } else {
            if (state.listChips![2].check.indexOf(true) > -1) {
              return;
            }
            state.selectedChips![0].check.push("C");
            state.listChips![2].check[idx] = true;
            const month = state.listChips![2].code[idx];
            state.selectedChips![0].code.push(month);
            const startDate = moment().subtract(month, "month").format("YYYY-MM-DD");
            const endDate = moment().format("YYYY-MM-DD");
            codeName = startDate + "," + endDate;
          }
          state.selectedChips![0].index.push(idx);
          // setSearchContents(titleName + "_" + codeName + "_" + elementName);
          state.selectedChips![0].chip.push(elementName);
        }
      }
    },
    filterDelete: (state, action: PayloadAction<any>) => {
      const params = action.payload;
      const check = params.check;
      const selectIndex = params.selectIndex;
      const idx = params.idx;
      const code = params.code;
      // 선택 색상 제거
      if (check === "A") {
        state.listChips![0].check[selectIndex] = false;
      } else if (check === "B") {
        state.listChips![1].check[selectIndex] = false;
      } else {
        state.listChips![2].check[selectIndex] = false;
      }
      // // 선택한 조건 삭제
      state.selectedChips![0].check.splice(idx, 1);
      state.selectedChips![0].index.splice(idx, 1);
      state.selectedChips![0].chip.splice(idx, 1);
      state.selectedChips![0].code.splice(idx, 1);
    },
    setSearchContents: (state, action: PayloadAction<string>) => {
      // 검색어
      state.selectedChips![0].contents = action.payload;
    },
    setSearchOrderBy: (state, action: PayloadAction<string>) => {
      state.selectedChips![0].orderBy = action.payload;
    },
    setAsImage: (state, action: PayloadAction<Array<any>>) => {
      state.setDataList = [];
      if (action.payload.length > 0) {
        state.setDataList = action.payload;
      }
    },
    setPagination: (state, action: PayloadAction<number>) => {
      state.selectedChips![0].page = action.payload;
    },
    setAsCount: (state, action: PayloadAction<number>) => {
      state.asCount = action.payload;
    },
    setRecentKeyword: (state, action: PayloadAction<string>) => {
      state.searchContentsData = action.payload;
    },
    setSearchStartDate: (state, action: PayloadAction<string>) => {
      state.searchStartDate = action.payload;
    },
    setSearchEndDate: (state, action: PayloadAction<string>) => {
      state.searchEndDate = action.payload;
    },
    addRegisterIng: (state, action: PayloadAction<boolean>) => {
      state.ingAsRegister = action.payload;
    },
    addReportRegisterIng: (state, action: PayloadAction<boolean>) => {
      state.ingReportRegister = action.payload;
    },
  },
});

// 3. export

// 3-1. export actions
export const {
  initData,
  filterHandleClick,
  filterDelete,
  setSearchContents,
  setSearchOrderBy,
  setAsImage,
  setPagination,
  setAsCount,
  setRecentKeyword,
  setSearchStartDate,
  setSearchEndDate,
  addRegisterIng,
  addReportRegisterIng,
} = asSlice.actions;
// 3-2. export default slice.reducer
export default asSlice.reducer;
